'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Content = require('./../../helpers/Content');

var _Content2 = _interopRequireDefault(_Content);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OurTeam = function (_Component) {
  (0, _inherits3.default)(OurTeam, _Component);

  function OurTeam() {
    (0, _classCallCheck3.default)(this, OurTeam);
    return (0, _possibleConstructorReturn3.default)(this, (OurTeam.__proto__ || (0, _getPrototypeOf2.default)(OurTeam)).apply(this, arguments));
  }

  (0, _createClass3.default)(OurTeam, [{
    key: 'render',
    value: function render() {
      var styles = require('./OurTeam.scss');
      var photoIntro = require('./our-team-intro.jpg');
      var domca = require('./dominika-krupkova.png');
      var krupino = require('./tomas-krupka.jpg');
      var filip = require('./filip-zettl.jpg');
      var borec = require('./tomas-kavka.jpg');

      var data = {
        intro: {
          text: 'Rádi bychom vám představili náš tým trenérů a především sportovních nadšenců, kteří budou na táborech a ve sportovní přípravce předávat své zkušenosti a učit vaše děti.',
          image: {
            src: photoIntro,
            alt: 'Tým Nenudím se'
          }
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactHelmet2.default, {
          title: 'N\xE1\u0161 t\xFDm tren\xE9r\u016F, instruktor\u016F a sportovn\xEDch nad\u0161enc\u016F',
          meta: [{
            name: 'description',
            content: 'Náš tým trenérů, instruktorů a sportovních nadšenců, kteří naučí vaše děti běhat, skákat, házet a především se radovat z pohybu.'
          }, {
            property: 'og:description',
            content: 'Náš tým trenérů, instruktorů a sportovních nadšenců, kteří naučí vaše děti běhat, skákat, házet a především se radovat z pohybu.'
          }, {
            property: 'og:title',
            content: 'Náš tým trenérů, instruktorů a sportovních nadšenců'
          }, {
            name: 'keywords',
            content: 'tym, nenudim se, nenudimse, sport, sport dětí, sportovní přípravka, sport pro děti, atletika, běhaní, sportovní kroužek, instruktor, lyžování'
          }],
          link: [{ rel: 'canonical', href: 'https://www.nenudimse.cz/nas-tym' }] }),
        _react2.default.createElement(
          'header',
          null,
          _react2.default.createElement(
            'h1',
            null,
            'N\xE1\u0161 t\xFDm',
            _react2.default.createElement(
              'small',
              null,
              'tren\xE9r\u016F, instruktor\u016F a sportovn\xEDch nad\u0161enc\u016F'
            )
          )
        ),
        _Content2.default.renderIntro(styles, data.intro),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { id: 'tomas-krupka', className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-0' },
              _react2.default.createElement('img', { width: '100%', src: krupino, alt: 'Tom\xE1\u0161 Krupka' })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-10' },
              _react2.default.createElement(
                'h2',
                null,
                'Tom\xE1\u0161 Krupka'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Tom\xE1\u0161 je tren\xE9rem mlad\u0161\xEDho \u017Eactva, kter\xFD aktu\xE1ln\u011B vede dv\u011B skupiny atletick\xE9 p\u0159\xEDpravky na ASK Slavia Praha. B\u011Bhem sv\xE9 dlouholet\xE9 atletick\xE9 kari\xE9ry se z\xFA\u010Dastnil Mistrovstv\xED sv\u011Bta junior\u016F v polsk\xE9 Bydho\u0161ti, n\u011Bkolikr\xE1t reprezentovat \u010CR na trati 400 metr\u016F a ve \u0161tafet\xE1ch. Tom\xE1\u0161 je tak\xE9 instruktorem ly\u017Eov\xE1n\xED a absolvoval mas\xE9rsk\xFD kurz.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'dominika-krupkova', className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-0' },
              _react2.default.createElement('img', { width: '100%', src: domca })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-10' },
              _react2.default.createElement(
                'h2',
                null,
                'Dominika Krupkov\xE1'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Dominika moment\xE1ln\u011B u\u010D\xED na FTVS na kated\u0159e sport\u016F v p\u0159\xEDrod\u011B a z\xE1rove\u0148 studuje doktorsk\xE9 studium. Je tren\xE9rkou 3. atletick\xE9 t\u0159\xEDdy a m\xE1 n\u011Bkolikaletou zku\u0161enost s tr\xE9nov\xE1n\xEDm d\u011Bt\xED v r\xE1mci atletick\xE9 p\u0159\xEDpravky na ASK Slavia Praha. M\xE1 kurzy v\xFD\u017Eivov\xE9ho poradenstv\xED, prvn\xED pomoci a je instruktorkou ly\u017Eov\xE1n\xED, lezen\xED a vodn\xED turistiky.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'filip-zettl', className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-0' },
              _react2.default.createElement('img', { width: '100%', src: filip })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-10' },
              _react2.default.createElement(
                'h2',
                null,
                'Filip Zettl'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Filip absolvoval sportovn\xED z\xE1kladn\xED \u0161kolu Jeseniova, kterou reprezentoval na atletick\xFDch z\xE1vodech. V sou\u010Dasn\xE9 dob\u011B studuje zdravotnickou \u0161kolu. M\xE1 za sebou n\u011Bkolikaletou zku\u0161enost s tr\xE9nov\xE1n\xEDm mal\xFDch d\u011Bt\xED. V Nenud\xEDm se vede 2 tr\xE9ninkov\xE9 skupiny a b\u011Bhem ly\u017Ea\u0159sk\xFDch kurz\u016F exceluje jako instruktor ly\u017Eov\xE1n\xED. R\xE1d si zahraje florbal, volejbal a jeho kon\xED\u010Dkem je v\xFDchova mal\xE9ho J\xE1chyma.'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { id: 'tomas-kavka', className: (0, _classnames2.default)('row', styles.person) },
            _react2.default.createElement(
              'div',
              { className: 'col-xs-4 col-xs-offset-4 col-sm-2 col-sm-offset-0' },
              _react2.default.createElement('img', { width: '100%', src: borec })
            ),
            _react2.default.createElement(
              'div',
              { className: 'col-xs-12 col-sm-10' },
              _react2.default.createElement(
                'h2',
                null,
                'Tom\xE1\u0161 Kavka'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Tren\xE9r mlad\u0161\xEDho \u017Eactva, kter\xFD vede skupinu atletick\xE9 p\u0159\xEDpravky na ASK Slavia Praha. Tom\xE1\u0161 je n\u011Bkolikan\xE1sobn\xFD mistr republiky v b\u011Bhu na 110 metr\u016F s p\u0159ek\xE1\u017Ekami. Mimo to reprezentoval na Mistrovstv\xED sv\u011Bta junior\u016F a na Mistrovstv\xED Evropy do 23 let v Ostrav\u011B, kde se stal spoludr\u017Eitelem dnes ji\u017E p\u0159ekonan\xE9ho \u010Desk\xE9ho rekordu na 4x100 metr\u016F.'
              )
            )
          )
        )
      );
    }
  }]);
  return OurTeam;
}(_react.Component);

exports.default = OurTeam;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/OurTeam/OurTeam.js
// module id = 1111
// module chunks = 0